import { formComponents as fc } from "@/components/form";
import { ui } from "@/components/ui";
import { useShockwaveMutation } from "@/features/shockwave/api/upsertShockwave";
import type { ExtendedShockwaveViewT } from "@/types/database/events";
import { zodResolver } from "@hookform/resolvers/zod";
import { type SubmitHandler, useForm } from "react-hook-form";
// import InviteDialog from '../../invite/components/InviteDialog';
import {
    type ShockwaveSchemaT,
    ShockwaveSchemaZ,
} from "../types/shockwaveSchema";
import ShockwaveFormFields from "./ShockwaveFormFields";

interface Props {
    organisationId: string;
    diaryId: string;
    eventId: string;
    shockwaveId: string;
    shockwave?: ExtendedShockwaveViewT;
    onSuccess?: () => void;
    isDialog?: boolean;
}
const ShockwaveForm = ({
    diaryId,
    eventId,
    shockwaveId,
    shockwave,
    organisationId,
    onSuccess,
    isDialog = false,
}: Props) => {
    const shockwaveMutation = useShockwaveMutation({ diaryId: diaryId });

    const form = useForm<ShockwaveSchemaT>({
        resolver: zodResolver(ShockwaveSchemaZ),
        defaultValues: {
            event_id: eventId,
            shockwave_id: shockwaveId,
            referring_clinician_id: shockwave?.referring_clinician_id ??
                undefined,
            shockwaving_clinician_id: shockwave?.shockwaving_clinician_id ??
                undefined,
        },
    });

    const onSubmit: SubmitHandler<ShockwaveSchemaT> = async (formData) => {
        shockwaveMutation.mutate(formData, { onSuccess: onSuccess });
    };

    return (
        <ui.Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="form">
                <ShockwaveFormFields organisationId={organisationId} />
                <fc.SaveButton isDialog={isDialog} />
            </form>
        </ui.Form>
    );
};

export default ShockwaveForm;
